import { formatDateVi } from "../../../utils/dateUtils";

export const formatProductImportHistoryDate = (date: string | Date): string =>
  formatDateVi(new Date(date));
